// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YGyy6QBlk1kIQqv3 {
  margin: 15px 32px 0;
}
.f0aqFJo_qQ98RUfK {
  display: flex;
  height: 49px;
  position: relative;
}
.ICmkX28mdWYMt3jw {
  width: 160px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-right: 1px;
  text-align: center;
  line-height: 48px;
  background: #f3f6fa;
  cursor: pointer;
  color: #666666;
}
.HBC_DIkNsOs5mwdP {
  background: #ffffff;
  height: 49px;
  transition: 0.3s;
  color: #333;
  font-weight: bold;
}
.fyLexDweV0_zVehT {
  position: absolute;
  height: 48px;
  align-items: center;
  right: 0;
  top: 10px;
}
.UjUggjcAhfg7GrO1 {
  width: 24px;
  height: 24px;
  color: #999;
  cursor: pointer;
}
.UjUggjcAhfg7GrO1:hover {
  color: #0095FC;
}
.WuvDvJqkL9gB_msn {
  background: #fff;
  height: calc(100vh - 340px);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow-y: auto;
}
.XQGXBvU_R4iBBI3Y {
  color: #0095FC;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/Tabs/tabs.modules.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACA;EACE,aAAA;EAEA,YAAA;EACA,kBAAA;AAAF;AAEA;EACE,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAAF;AAEA;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAAF;AAEA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;AAAF;AAEA;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAAJ;AACI;EACE,cAAA;AACN;AAEA;EACE,gBAAA;EACA,2BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gBAAA;AAAF;AAEA;EACE,cAAA;AAAF","sourcesContent":[".wrapper {\n  margin: 15px 32px 0;\n}\n.tabsContainer {\n  display: flex;\n  // border-bottom: 1px solid #e6e6e6;\n  height: 49px;\n  position: relative;\n}\n.content {\n  width: 160px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  margin-right: 1px;\n  text-align: center;\n  line-height: 48px;\n  background: #f3f6fa;\n  cursor: pointer;\n  color: #666666;\n}\n.tabActive {\n  background: #ffffff;\n  height: 49px;\n  transition: 0.3s;\n  color: #333;\n  font-weight: bold;\n}\n.operator {\n  position: absolute;\n  height: 48px;\n  align-items: center;\n  right: 0;\n  top: 10px;\n}\n.operatorIcon {\n    width: 24px;\n    height: 24px;\n    color: #999;\n    cursor: pointer;\n    &:hover {\n      color: #0095FC;\n    }\n}\n.tab_content {\n  background: #fff;\n  height: calc(100vh - 340px);\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  overflow-y: auto;\n}\n.current {\n  color: #0095FC;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `YGyy6QBlk1kIQqv3`,
	"tabsContainer": `f0aqFJo_qQ98RUfK`,
	"content": `ICmkX28mdWYMt3jw`,
	"tabActive": `HBC_DIkNsOs5mwdP`,
	"operator": `fyLexDweV0_zVehT`,
	"operatorIcon": `UjUggjcAhfg7GrO1`,
	"tab_content": `WuvDvJqkL9gB_msn`,
	"current": `XQGXBvU_R4iBBI3Y`
};
export default ___CSS_LOADER_EXPORT___;
